import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './index.css';

interface IModalFooterProps {
  onOtpModalFooterSubmit: () => void;
  isResendActive?: boolean;
  buttonLabel: string;
  counter: number;
  onResend: () => void;
  disabledOtpSubmit: boolean;
}

const OTPInputModalFooter: React.FC<IModalFooterProps> = ({
  isResendActive,
  onOtpModalFooterSubmit,
  buttonLabel,
  counter,
  onResend,
  disabledOtpSubmit,
}) => {
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  const { t } = useTranslation();

  return (
    <div className='footerRoot'>
      <Button
        className='primaryButton'
        loading={loading}
        id='submitButton'
        disabled={disabledOtpSubmit}
        onClick={onOtpModalFooterSubmit}
      >
        {buttonLabel}
      </Button>

      {isResendActive && (
        <Button
          disabled={counter !== 0}
          className='primaryButton'
          id='resendButton'
          type='text'
          onClick={onResend}
        >
          {t('RESEND')} {counter !== 0 && `in ${counter}`}
        </Button>
      )}
    </div>
  );
};

export default OTPInputModalFooter;
